export const maxNotificationsCount = 99
